import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { useCurrentScenarioData } from '../../state/hooks/ScenarioHooks';
import { useGetDataVectorTwingraphQueriesResults, useTwingraphQueriesStatus } from '../../state/wizard/WizardHooks';
import VecteurDonnees from './VecteurDonnees';

const DataVector = ({ context }) => {
  const status = useTwingraphQueriesStatus();
  const scenarioData = useCurrentScenarioData();
  const datasetId = scenarioData.datasetList[0];
  const getTwingraphQueriesResults = useGetDataVectorTwingraphQueriesResults(scenarioData);
  useEffect(() => {
    getTwingraphQueriesResults(datasetId);
  }, [datasetId, getTwingraphQueriesResults, scenarioData]);

  return status === 'LOADING' ? (
    <CircularProgress data-cy="data-vector-queries-loading-spinner" />
  ) : (
    <VecteurDonnees context={context} />
  );
};

DataVector.propTypes = {
  context: PropTypes.object,
};
export default DataVector;
